import React, { Component } from 'react';
import { Label } from 'office-ui-fabric-react/lib/Label';

export class Upload extends Component {

    static defaultProps = {
        label: "", // label à afficher
        multiple: false, // indique si le contrôle prend en charge l'upload de plusieurs fichiers
        onChange: () => null, // événement déclenché lors du chargement du fichier
        value: undefined // valeur lors de la modification
    };

    render = () => {

        const { label, multiple, onChange, value } = this.props;

        return <div>
            <Label>{label}</Label>
            {!!value && <img alt={label} src={`data:image/png;base64,${value}`} style={{ width: '80px', height: '80px' }} />}
            <input type="file" multiple={multiple} onChange={onChange} />
        </div>;
    };

};